// Mirrors internal/api/server.go::apiListing.
export type Status =
  | "Inbox"
  | "Interesting"
  | "Contacted"
  | "Viewing"
  | "Applied"
  | "Rejected";

export const STATUSES: Status[] = [
  "Inbox",
  "Interesting",
  "Contacted",
  "Viewing",
  "Applied",
  "Rejected",
];

export interface Listing {
  id: string;
  source: string;
  externalId: string;
  url: string;
  title: string;
  priceCHF: number;
  rooms: number;
  surfaceM2: number;
  street: string;
  zipcode: string;
  city: string;
  lat: number;
  lng: number;
  description: string;
  coverImageUrl: string;
  imageUrls: string[];
  attributes: string[];
  furnished: boolean;
  temporary: boolean;
  movingDate: string;
  agencyName: string;
  status: Status;
  notes: string;
  viewingDate: string | null;
  firstSeen: string;
}

export interface UpdateListingPayload {
  status?: Status;
  notes?: string;
  viewingDate?: string | null;
}
